export const prefix = "@@syw-application/";

export const SETUP_APPLICATION = `${prefix}SETUP_APPLICATION`;
export const DESTROY_APPLICATION = `${prefix}DESTROY_APPLICATION`;
export const UPDATE_ACTIVE_STEP = `${prefix}UPDATE_ACTIVE_STEP`;
export const UPDATE_OPENED_CARDS = `${prefix}UPDATE_OPENED_CARDS`;
export const REGISTER_FIELD = `${prefix}REGISTER_FIELD`;
export const UNREGISTER_FIELD = `${prefix}UNREGISTER_FIELD`;
export const UPDATE_FIELD = `${prefix}UPDATE_FIELD`;
export const TRIGGER_FIELD_ACTIONS = `${prefix}TRIGGER_FIELD_ACTIONS`;
export const VERIFY_SAVED_CARDS = `${prefix}VERIFY_SAVED_CARDS`;
export const UPDATE_SAVED_CARDS = `${prefix}UPDATE_SAVED_CARDS`;
export const UPDATE_SUBMITTED_APPLICATION = `${prefix}UPDATE_SUBMITTED_APPLICATION`;
